import styled from "styled-components";

export const SpanComponent = styled.li`
  display: flex;
  align-items: center;

  width: fit-content;
  height: 1rem;
  padding: 5px 10px;

  font-size: 0.75rem;

  border-radius: 8px;
  background: linear-gradient(
    102.18deg,
    rgba(211, 0, 0, 0.4) 30.17%,
    rgba(73, 0, 0, 0) 135.52%
  );
  color: var(--color-white-0);
  box-shadow: var(--box-shadow);
`;
